import { useEffect } from "react";
import { map, unescape } from "lodash";
import { selectContractsStore, useBoundStore } from "@/services/stores";
import { useRequestState } from "@/hooks";
import { ContractsPayload, requestContractList } from "@/services/api";
import { logger } from "@/utils";

export const useContracts = ({
  email,
  contractorId,
  companyId,
}: ContractsPayload) => {
  const { contracts, setContracts } = useBoundStore(selectContractsStore);

  const { error, setError, isLoading, setInProgress, setSuccess } =
    useRequestState({
      isLoading: !!companyId,
    });

  useEffect(() => {
    const controller = new AbortController();

    if (companyId) {
      setInProgress();
      requestContractList(
        {
          email,
          contractorId,
          companyId,
        },
        { signal: controller.signal },
      )
        .then(response => {
          setContracts(response);
          setSuccess(response);
        })
        .catch(error => {
          setError(error.message);

          logger.error(error);
        });
    }

    return () => {
      controller.abort();
    };
  }, [
    companyId,
    contractorId,
    email,
    setContracts,
    setError,
    setInProgress,
    setSuccess,
  ]);

  return {
    isLoading,
    contracts: map(contracts, contract => {
      return {
        ...contract,
        Value: unescape(contract.ContractNo),
      };
    }),
    error,
  };
};
